import { GTMAccommodationItem } from "@/helpers/gtm/GTMAccommodationItem.ts";
import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { RateGroup } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect } from "react";
import TagManager from "react-gtm-module";

export const useGTMAccommodationList = () => {
  const availableRateGroups = useEngineStore((state) => state.availableRateGroups);

  const sendGTMEvent = (availableRateGroups: RateGroup[]) => {
    const GTM_RG_Info = availableRateGroups?.flatMap((RG) => {
      return RG.ratePlans?.map(
        (RP, index): GTMAccommodationItem => ({
          item_id: RP.id,
          item_name: RP.name,
          currency: "EUR",
          price: RP.defaultPriceBreakdown.withDiscount,
          index,
          item_category: RG.name,
        }),
      );
    });

    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.ViewItemList,
        ecommerce: {
          items: GTM_RG_Info,
        },
      },
    });
  };

  useEffect(() => {
    sendGTMEvent(availableRateGroups);
  }, [availableRateGroups]);
};
